module.exports = __webpack_public_path__ + "img/logoMainNav-dark.d5b5b8ea.webp";